import { BaseDataGridRequest } from "../base-data-grid.request";

export interface GetServicesRequest extends BaseDataGridRequest {
  id?: string;
  objectType?: string;
  action?: string;
  size?: string;
  weight?: number;
  locationId?: string;
  jobId?: string;
  locationName?: string;
  customColumnSearch?: string;
  createdAt?: Date;

}
